<template>
  <div>
    <b-button v-b-modal.test-modal variant="primary">Dodaj nowego</b-button>
    <ModalFormTest
      v-on:submitSuccess="this.handleSubmitSuccess"
      v-on:onClose="this.handleCloseForm"
      :form="this.selected"
    ></ModalFormTest>
    <h5>Adresy e-mail z formularza:</h5>
    <ul>
      <li v-for="(item, index) in listEmail" :key="index">
        <b-form-group>
          {{item.name}} &lt;{{ item.email }}&gt;
          <b-button
            size="sm"
            variant="outline-primary"
            @click="editEmail(index)"
            ref="btnShow"
          >edytuj</b-button>
        </b-form-group>
      </li>
    </ul>

    <div>
      <h2>Test API i Toast</h2>
      <b-button variant="outline-danger" class="mr-1" v-on:click="submitError">Error</b-button>
      <b-button
        variant="outline-secondary"
        v-on:click="submitFormError"
      >Błędnie wypełniony formularz</b-button>
      <br />
      <br />
      <br />
    </div>
    <div>
      <h2>Tagging</h2>
      <multiselect
        v-model="value"
        tag-placeholder="Add this as new tag"
        placeholder="Search or add a tag"
        label="name"
        track-by="code"
        :options="options"
        :multiple="true"
        :taggable="true"
        @tag="addTag"
      ></multiselect>
      <pre class="language-json"><code>{{ value  }}</code></pre>
    </div>

    <div>
      <h2>Modal dla wydawania towarów</h2>
      <b-button v-b-modal.take-materials-modal variant="primary">Wydawaj towar</b-button>
      <ModalTakeMaterials></ModalTakeMaterials>
    </div>

  </div>
</template>

<script>
import ModalFormTest from "../components/Test/ModalFormTest";
import ModalTakeMaterials from "../components/warehouse/ModalTakeMaterials";
// import ApiService from "@/services/api.service";

export default {
  name: "TheTests",
  components: { ModalFormTest, ModalTakeMaterials },
  data() {
    return {
      listEmail: [
        { email: "test@test.test", name: "Jan" },
        { email: "abc@abc.abc", name: "Adam" },
        { email: "zxc@zxc.zxc", name: "Edward" },
        { email: "asd@asd.asd", name: "Kamil" },
        { email: "qwe@qwe.qwe", name: "Zygmunt" }
      ],
      selected: undefined,
      value: [{ name: "Javascript", code: "js" }],
      options: [
        { name: "Vue.js", code: "vu" },
        { name: "Javascript", code: "js" },
        { name: "Open Source", code: "os" },
        { name: "React", code: "rc" },
        { name: "Angular", code: "ag" },
        { name: "Angular2", code: "ag2" }
      ]
    };
  },
  methods: {
    handleSubmitSuccess(e) {
      if (this.selected) {
        this.$_.each(e, (value, key) => {
          this.selected[key] = value;
        });
      } else {
        this.listEmail.push(e);
      }
    },
    handleCloseForm() {
      this.selected = null;
    },
    editEmail(index) {
      this.selected = this.listEmail[index];
      this.$nextTick(() => {
        this.$bvModal.show("test-modal");
      });
    },

    // submitError() {
    //   ApiService.get("/error", {}).then(response => {
        // console.log("-----RESPONSE---");
        // console.log(response);
    //   });
    // },
    // submitFormError() {
    //   ApiService.post("/formtest", {}).then(response => {
        // console.log("-----RESPONSE---");
        // console.log(response);
      // });
      // .catch(error => {
      //   //Tip: tutaj można przechwytywać błedy
      //   // console.log(error.response.data.fields);
      // });
    // },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
    }
  }
};
</script>